<template>
  <el-dialog
    title="Add companies"
    :visible.sync="visible"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main v-loading="fetchInProgress">
        <el-form ref="form" label-position="top" :model="form">
          <el-row class="margin-bottom-20" :gutter="20">
            <el-col :span="6">
              <el-form-item class="search-form-item" label="">
                <el-input
                  v-model="form.search"
                  prefix-icon="el-icon-search"
                  class="search"
                  placeholder="Search"
                  clearable
                  :disabled="fetchInProgress"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="flex items-center">
          <el-pagination
            v-show="availableApplications.length > pageSize"
            layout="prev, pager, next"
            :current-page.sync="page"
            :total="availableApplications.length"
          />

          <span v-if="selectedItems.length" class="ml-4 inline-block">
            {{ selectedItems.length }}&nbsp;{{
              pluraize(selectedItems.length, 'row')
            }}
            selected
          </span>
        </div>

        <el-table
          :data="applications"
          :defualt-sort="{ prop: 'startup_name', order: 'descending' }"
          :row-key="getRowKey"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column type="expand">
            <template slot-scope="{ row }">
              <div
                v-for="rating in row.ratings.all"
                :key="rating.user.id"
                class="user-rating row"
              >
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <StartupRate :value="rating.overall" read-only muted />
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  {{ rating.user.email }}
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                  <p>{{ rating.note }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Company" prop="startup_name" sortable />
          <el-table-column label="Submitted at" prop="submitted_at" sortable>
            <template slot-scope="{ row }">
              <span v-if="row.submitted_at">{{ row.submitted_at | date }}</span>
              <span v-if="!row.submitted_at">pending</span>
            </template>
          </el-table-column>
          <el-table-column label="Rating" prop="rating_avg" sortable>
            <template slot-scope="{ row }">
              {{ row.rating_avg ? row.rating_avg.toFixed(1) : '-' }}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <el-footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="addSelected()">
          Add selected
        </el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
import StartupRate from 'components/StartupRate.vue'
import _ from 'lodash'
import { pluraize, searchObjectsByKey } from 'utils'
import { mapState } from 'vuex'

export default {
  components: { StartupRate },
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    alreadySelected: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    availableApplications() {
      const alreadySelectedSet = new Set()
      this.alreadySelected.forEach((s) => {
        alreadySelectedSet.add(s.id)
      })
      let applications = this.allApplications
        .filter((a) => !alreadySelectedSet.has(a.startup_id)) // filter out already selected
        .map((a) => ({ ...a, rating_avg: a.ratings.overall_avg }))

      if (this.form.search) {
        applications = searchObjectsByKey(
          applications,
          'startup_name',
          this.form.search,
        )
      }

      return _.sortBy(applications, (a) => {
        return -a.ratings.overall_avg || 0
      })
    },

    applications() {
      const idx = (this.page - 1) * this.pageSize
      return this.availableApplications.slice(idx, idx + this.pageSize)
    },

    ...mapState({
      allApplications: (s) => s.organizationProgramApplications.applications,
      fetchInProgress: (s) => s.organizationProgramApplications.fetchInProgress,
    }),
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      visible: false,
      selectedItems: [],
      form: { search: '' },
    }
  },
  methods: {
    open() {
      this.visible = true
      this.fetch()
    },

    async fetch() {
      const organizationId = this.event.organization.id
      this.$store.dispatch('organizationProgramApplications/fetch', {
        organizationId,
      })
    },

    handleSelectionChange(items) {
      this.selectedItems = items
    },

    addSelected() {
      console.log(' => selectedItems going to be added', this.selectedItems)
      this.$emit('add', this.selectedItems)
      this.visible = false
    },

    getRowKey(row) {
      return row.id
    },

    pluraize(count, noun) {
      return pluraize(count, noun)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  height: 100px;
}
</style>
